module.exports = __webpack_public_path__ + "static/media/film-canister.8c753858.svg";